export default __webpack_public_path__ + "static/media/PHONE_2.8b156400.webm";